import React from 'react';
import styled from 'styled-components';
import { Flex } from '../components/Flex';

const ResultContainer = styled(Flex)`
  margin-left: 0px;
`;

const ColorSearchResult = styled.span`
  color: var(--search-text-color-result);
  font-weight: 500;
  margin: 0 1px;
`;

const SearchText = styled.div<{ $space: number }>`
  color: var(--search-text-color);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  ${({ $space }) => $space && 'margin-left: 2px;'}
`;

const SearchTextStart = styled.div<{ $space: number }>`
  color: var(--search-text-color);
  min-width: fit-content;
  width: fit-content;
  ${({ $space }) => $space && 'margin-right: 2px;'}
`;

const SearchTextBox = styled.div`
  color: var(--search-text-color);
  min-width: fit-content;
  width: fit-content;
  padding-bottom: 8px;
`;

export const getSplitText = (text: string, searchValue: string, isTextBox?: boolean) => {
  const textIndex = text?.toLowerCase().indexOf(searchValue?.toLowerCase());
  const start = text?.substring(0, textIndex);
  const color = text?.substring(textIndex, textIndex + searchValue.length);
  const end =
    color === searchValue
      ? `${text?.substring(textIndex + searchValue.length, text.length)}`
      : text?.substring(textIndex + searchValue.length, text.length);

  return isTextBox ? (
    <ResultContainer id="sr">
      <SearchTextBox>
        {start}
        <ColorSearchResult>{color}</ColorSearchResult>
        {end}
      </SearchTextBox>
    </ResultContainer>
  ) : (
    <ResultContainer id="sr">
      {textIndex > 0 && (
        <SearchTextStart id="sr" $space={start.slice(-1) === ' ' || color.charAt(0) === ' ' ? 1 : 0}>
          {start}
        </SearchTextStart>
      )}
      <ColorSearchResult id="sr">{color}</ColorSearchResult>
      <SearchText id="sr" $space={color.slice(-1) === ' ' || end.charAt(0) === ' ' ? 1 : 0}>
        {end}
      </SearchText>
    </ResultContainer>
  );
};
